import { FC } from "react";

type Props = {
  text: string;
  visible: boolean;
  position: "top" | "bottom" | "left" | "right";
  children: React.ReactNode;
};

export const Tooltip: FC<Props> = ({
  text,
  children,
  visible = true,
  position,
}) => {
  const classes = () => {
    switch (position) {
      case "top":
        return "absolute left-1/2 transform -translate-x-1/2 bottom-full mb-2";
      case "bottom":
        return "absolute left-1/2 transform -translate-x-1/2 top-full mt-2";
      case "left":
        return "absolute right-full top-1/2 transform -translate-y-1/2 mr-2";
      case "right":
        return "absolute left-full top-1/2 transform -translate-y-1/2 ml-2";

      default:
        return "absolute left-1/2 transform -translate-x-1/2 bottom-full mb-2";
    }
  };

  return (
    <div className="relative group">
      {children}
      {visible && (
        <div
          className={[
            classes(),
            "w-52 hidden group-hover:block bg-slate-600 text-white text-xs rounded py-1 px-2 z-10 transition-opacity duration-300 opacity-0 group-hover:opacity-100",
          ].join(" ")}
        >
          {text}
        </div>
      )}
    </div>
  );
};
